export const RIIOTEVENTHUB = {
    validateCosmosDBAccName: 'api/azure/lookups/1.0/validate-cosmos-database-account-name',
    validateDLStorageAccName: 'api/azure/lookups/1.0/validate-data-lake-storage-account-name',
    validateClusterName: 'api/azure/lookups/1.0/validate-cluster-name',
    validateServiceBusNamespace: 'api/azure/lookups/1.0/validate-service-bus-namespace',
    submitApproval: 'api/order/v2/1.0/internal/order/submit-approval',
    Jwt: {
        // provisioning
        siteName: 'api/static/lookups/v2/1.0/sitename',
        previewOrder: 'api/reference-implementation/web-application/2.0/internal/order/riioteventhub/preview',
        submitOrder: 'api/reference-implementation/web-application/2.0/internal/order/riioteventhub/submit',
        reSubmit: 'api/reference-implementation/web-application/2.0/internal/order/riioteventhub/resubmit',
        costCalculation: 'api/costs/1.0/ri/cost-calculation',
        internalPreviewOrder: 'api/reference-implementation/web-application/1.0/internal/preview/order',
        downloadTF: 'api/reference-implementation/web-application/1.0/internal/order',
        serviceAccountApi: 'api/day2/order/service-accounts/validate',
        validateKafkaApi: 'api/eip/lookups/2.0/validate-kafka-topic',
        internalServiceAccount: 'api/day2/1.0/internal/validate-service-account',
        serviceAccountYesValidation: 'api/ri/resource/name/1.0/service-account/validate',
        serviceAccountNoValidation: 'api/day2/1.0/internal/validate-service-account',
    },
};
export default RIIOTEVENTHUB;
